/*
  A list of collapsible rows.

  Deliberately generic rather than part of the FAQ section: the product page
  has the same behaviour in its own script, and any future section that
  needs collapsible rows can use this element instead of a third copy.

  Rows are a button and a panel rather than <details>, because a closed
  <details> stops rendering its content entirely and so has nothing to
  animate. The height animation itself is CSS; this only flips the state.
*/
if (!customElements.get('accordion-list')) {
  class AccordionList extends HTMLElement {
    connectedCallback() {
      this.single = this.hasAttribute('data-single');
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const toggle = event.target.closest('[data-accordion-toggle]');
      if (!toggle) return;

      const row = toggle.closest('[data-accordion]');
      if (!row) return;

      const isOpen = row.hasAttribute('open');

      // With data-single, opening one closes the rest, so the list never
      // grows long enough to lose the row that was just opened off screen.
      if (this.single && !isOpen) {
        this.querySelectorAll('[data-accordion][open]').forEach((other) => {
          if (other === row) return;
          other.removeAttribute('open');
          const otherToggle = other.querySelector('[data-accordion-toggle]');
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        });
      }

      row.toggleAttribute('open', !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
    }
  }

  customElements.define('accordion-list', AccordionList);
}
